<template>
	<img :src="validUrl" @error="setImageUrl" />
</template>

<script>
	import appSettings from "../../../appconfig.json"

    export default {
		name: 'ProfileImage',
		props: {
			imageUrl: ""
		},
		data: function () {
			return {
				defaultImage: require("@/assets/images/user.png")
			}
		},
		computed: {
			validUrl: function () {
				if (this.imageUrl == "")
					return this.defaultImage

				return `${appSettings.mopaneApi.imageUrl}/${this.imageUrl}`
			}
		},
		methods: {
			setImageUrl: function (e) {
				e.target.src = this.defaultImage
			}
		}
    };
</script>

<style scoped>
</style>